/**
 * Copyright Aquera Inc 2023
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';

/**
 * Option_2 CSS
 */
export const styles = css`
  :host {
    display: block;
    user-select: none;
    -webkit-font-smoothing: var(--nile-webkit-font-smoothing, var(--ng-webkit-font-smoothing));
    -moz-osx-font-smoothing: var(--nile-moz-osx-font-smoothing, var(--ng-moz-osx-font-smoothing));
    text-rendering: var(--nile-text-rendering, var(--ng-text-rendering));
  }

  :host(:focus) {
    outline: none;
  }

  .option {
    position: relative;
    display: flex;
    align-items: center;
    font-size: var(--nile-type-scale-3, var(--ng-font-size-text-md));
    font-weight: var(--nile-font-weight-regular, var(--ng-font-weight-medium));
    line-height: var(--nile-line-height-1-8, var(--ng-line-height-text-md));
    letter-spacing: normal;
    color: var(--nile-color-dark-1, var(--ng-colors-text-primary-900));
    padding: var(--nile-spacing-sm, var(--ng-spacing-md)) var(--nile-spacing-none, var(--ng-spacing-md));
    transition: 150ms fill;
    font-family: var(--nile-font-family-serif, var(--ng-font-family-body));
    cursor: pointer;
    margin-bottom: var(--nile-spacing-none, var(--ng-spacing-xxs) )
  }

  .option--single-select {
    padding: var(--nile-spacing-9px, var(--ng-spacing-md)) var(--nile-spacing-lg, var(--ng-spacing-md));
  }

  .option--hover:not(.option--current):not(.option--disabled) {
    background-color: var(--nile-colors-primary-100, var(--ng-colors-bg-active));
    color: var(--nile-colors-dark-900, var(--ng-colors-text-primary-900));
    border-radius: var(--nile-radius-none, var(--ng-radius-sm));
  }

  .option--current,
  .option--current.option--disabled {
    background-color: var(--nile-colors-primary-100, var(--ng-colors-bg-active));
    color: var(--nile-colors-primary-600, var(--ng-colors-text-primary-900));
    opacity: 1;
    border-radius: var(--nile-radius-none, var(--ng-radius-sm));
  }

  .option--disabled {
    outline: none;
    opacity: 0.5;
    cursor: not-allowed;
  }

  .option__label {
    flex: 1 1 auto;
    display: inline-block;
    line-height: 1.4;
    word-break: break-all;
  }

  .option .option__check {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    visibility: hidden;
    padding-inline-end: var(--nile-spacing-xs);
  }

  .option--selected .option__check {
    visibility: visible;
  }

  .option__prefix,
  .option__suffix {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
  }

  .option__prefix::slotted(*) {
    margin-inline-end: var(--nile-font-size-rem-xsmall, var(--ng-spacing-md));
  }

  .option__suffix::slotted(*) {
    margin-inline-start: var(--nile-font-size-rem-xsmall, var(--ng-spacing-md));
  }

  :host(:not([aria-selected='true'])) .option .option__suffix{
    display: var(--nile-display-block, var(--ng-display-none));
  }

  .option--checkbox{
    pointer-events: none;
    margin-left: var(--nile-spacing-lg, var(--ng-spacing-lg));
    margin-right: var(--nile-spacing-lg, var(--ng-spacing-lg));
    width:auto;
    display:var(--nile-display-inline-block, var(--ng-display-none));
  }


  @media (forced-colors: active) {
    :host(:hover:not([aria-disabled='true'])) .option {
      outline: dashed 1px SelectedItem;
      outline-offset: -1px;
    }
  }

  .option__label-container {
    display: flex;
    flex-direction: column;
  }

  .option__description {
    font-size: var(--nile-type-scale-2, var(--ng-font-size-text-sm));
    color: var(--nile-colors-dark-500, var(--ng-colors-text-tertiary-600));
  }

  .text-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    width: 99%;
  }

  .option__label-text-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    width: 99%;
  }
`;

export default [styles];
